import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  getSubtotal,
  getTotal,
  toggleResumen,
  setDefaults,
  getTextoIva,
  getTextoBotonResumen,
  getTextoBotonReset
} from '../../modules/reducer'

import IconEuro from './IconEuro'
import IconReplay from './IconReplay'

import {gaEvent} from '../../Cookies'

const MenuTotales = ({
  padding,
  subtotal,
  total,
  toggleResumen,
  setDefaults,
  textoIva,
  textoBotonResumen,
  textoBotonReset
}) => {
  const [solicitudReset, setSolicitudReset] = useState(false)

  const mq = window.matchMedia('(max-width: 823px)')

  let height = '40%'
  if (mq.matches) {
    height = '260px' //'20%'
  }

  return (
    <div
      className="col-12"
      style={{
        height,
        padding: `0 ${padding}px ${padding}px ${padding}px`
      }}
    >
      <div
        style={{
          backgroundColor: 'black',
          height: 1,
          marginTop: 30
        }}
      />
      <div style={{ paddingTop: 30 }}>
        <span>Subtotal:</span>
        <span style={{ paddingLeft: 5 }}>{subtotal}</span>
        <span>€</span>
      </div>
      <div style={{ paddingTop: 20 }}>
        <h3 style={{ margin: 0 }}>Total</h3>
      </div>
      <div>
        <IconEuro />
        <span style={{ paddingLeft: '1em', fontSize: '1.2em' }}>{total}</span>
      </div>
      <div style={{ fontSize: '0.8em' }}>{textoIva}</div>
      <div style={{ marginTop: 20 }}>
        <div
          className="button"
          style={{ backgroundColor: '#F07204' }}
          onClick={e => toggleResumen()}
        >
          {textoBotonResumen}
        </div>

        {solicitudReset ? (
          <div
            className="button"
            onClick={e => {
              gaEvent({
                category: 'Resetear configuración',
                action: 'Resetear configuración'
              })
              setSolicitudReset(!solicitudReset)
              setDefaults()
            }}
            style={{ backgroundColor: '#F07204', marginLeft: 10 }}
          >
            {textoBotonReset}
          </div>
        ) : (
          <IconReplay
            onClick={e => {
              setSolicitudReset(!solicitudReset)
            }}
            size={'2em'}
          />
        )}
      </div>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    subtotal: getSubtotal(reducer),
    total: getTotal(reducer),
    textoIva: getTextoIva(reducer),
    textoBotonResumen: getTextoBotonResumen(reducer),
    textoBotonReset: getTextoBotonReset(reducer)
  }
}

const mapDispatchToProps = { toggleResumen, setDefaults }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuTotales)
